import { createElement } from 'react';
import { node, string, bool, object, oneOfType, number } from 'prop-types';
import { breakpointPropType } from '../types/props.js';
import { withTheme } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Group';
import _Group from './styled.js';

var getVerticalBreakpoint = function getVerticalBreakpoint(_ref) {
  var breakpoint = _ref.breakpoint,
      theme = _ref.theme;
  return typeof breakpoint === 'number' ? breakpoint : _get(theme, "fannypack.layout[" + breakpoint + "Breakpoint]");
};

var Group = function Group(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      isVertical = _ref2.isVertical,
      theme = _ref2.theme,
      _verticalAt = _ref2.verticalAt,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "className", "isVertical", "theme", "verticalAt"]);

  var verticalAt = getVerticalBreakpoint({
    breakpoint: _verticalAt,
    theme: theme
  });
  return createElement(_Group, _extends({
    className: className,
    vertical: isVertical,
    verticalAt: verticalAt
  }, props), children);
};

var groupPropTypes = {
  children: node.isRequired,
  className: string,
  isVertical: bool,
  theme: object,
  verticalAt: oneOfType([breakpointPropType, number])
};
Group.propTypes = groupPropTypes;
var groupDefaultProps = {
  className: undefined,
  isVertical: false,
  theme: {},
  verticalAt: undefined
};
Group.defaultProps = groupDefaultProps; // @ts-ignore

var C = withTheme(Group);
export default C;
export { C as Group, groupDefaultProps, groupPropTypes };